// About Us — Find My Size, PDP inline injector
// Drops a "Find my size" button after the variant picker on every product page
// and opens a modal with the appropriate recommender (tops / bottoms / Aura).
(function () {
  if (typeof window === 'undefined') return;
  if (!/^\/products\//.test(location.pathname)) return;
  if (window.__aboutusFmsPdpLoaded) return;
  window.__aboutusFmsPdpLoaded = true;

  var SIZES_5 = ['XS', 'S', 'M', 'L', 'XL'];
  var SIZES_4 = ['S', 'M', 'L', 'XL'];
  var RANGES = {
    tops: [[84, 90], [90, 97], [97, 104], [104, 112], [112, 121]],
    bottoms: [[71, 76], [76, 82], [82, 89], [89, 97], [97, 105]],
    aura_bra_bust: [[82, 87], [87, 92], [92, 98], [98, 104]],
    aura_bra_underbust: [[68, 73], [73, 78], [78, 84], [84, 90]],
    aura_hip: [[88, 93], [93, 98], [98, 104], [104, 110]]
  };

  var COLLECTIONS = {
    tops: '/collections/all',
    bottoms: '/collections/native',
    aura: '/collections/aura'
  };

  var handle = decodeURIComponent(location.pathname.split('/products/')[1].split('/')[0].split('?')[0] || '');
  if (!handle) return;

  fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (product) {
      if (!product) return;
      var cat = classify(product);
      if (!cat) return;
      inject(cat, product);
    })
    .catch(function () {});

  function classify(p) {
    var h = (p.handle || '').toLowerCase();
    var ptype = (p.type || p.product_type || '').toLowerCase();
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var hay = h + ' ' + ptype + ' ' + tags.join(' ');
    if (/aura/.test(hay)) {
      if (/bra|crop|top/.test(hay)) return { kind: 'aura', garment: 'bra' };
      if (/legging|tight/.test(hay)) return { kind: 'aura', garment: 'leggings' };
      if (/short/.test(hay)) return { kind: 'aura', garment: 'shorts' };
      return { kind: 'aura', garment: 'shorts' };
    }
    if (/trackpant|sweatpant|joggers|pants/.test(hay)) return { kind: 'bottoms', label: 'Waist' };
    if (/hoodie|sweater|sweatshirt|jumper/.test(hay)) return { kind: 'tops', label: 'Chest' };
    if (/t-?shirt|tee|tshirt/.test(hay)) return { kind: 'tops', label: 'Chest' };
    if (/short/.test(hay)) return { kind: 'bottoms', label: 'Waist' };
    return null;
  }

  function inject(cat, product) {
    var anchor = findAnchor();
    if (!anchor) return;
    var btn = makeButton();
    anchor.parentNode.insertBefore(btn, anchor.nextSibling);
    var dialog = makeDialog(cat, product);
    document.body.appendChild(dialog);
    btn.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', 'open');
    });
  }

  function findAnchor() {
    var candidates = [
      'variant-picker',
      '[is="variant-picker"]',
      '.variant-picker',
      '[data-block-type="variant-picker"]',
      '.product-form__variants',
      'product-form variant-picker'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var firstAdd = form.querySelector('[name="add"], button[type="submit"]');
      if (firstAdd) return firstAdd.parentNode;
      return form;
    }
    return null;
  }

  function makeButton() {
    var wrap = document.createElement('div');
    wrap.id = 'aboutus-fms-pdp-trigger-wrap';
    wrap.style.cssText = 'margin:14px 0 6px;font-family:system-ui,-apple-system,sans-serif;';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'aboutus-fms-pdp-trigger';
    btn.textContent = 'Find my size →';
    btn.style.cssText = 'display:inline-flex;align-items:center;gap:8px;padding:10px 18px;border:1px solid #131936;background:#fff;color:#131936;font-family:system-ui,-apple-system,sans-serif;font-size:11px;letter-spacing:0.16em;text-transform:uppercase;cursor:pointer;font-weight:600;';
    btn.addEventListener('mouseenter', function () { btn.style.background = '#131936'; btn.style.color = '#C3B091'; });
    btn.addEventListener('mouseleave', function () { btn.style.background = '#fff'; btn.style.color = '#131936'; });
    wrap.appendChild(btn);
    return wrap;
  }

  function makeDialog(cat, product) {
    var dialog = document.createElement('dialog');
    dialog.id = 'aboutus-fms-pdp-dialog';
    dialog.style.cssText = 'padding:0;border:none;background:transparent;max-width:560px;width:92%;';
    dialog.innerHTML = '<style>' +
      '#aboutus-fms-pdp-dialog::backdrop{background:rgba(19,25,54,0.55);}' +
      '#aboutus-fms-pdp-dialog *{box-sizing:border-box;}' +
      '</style>';
    var card = document.createElement('div');
    card.style.cssText = 'background:#F4F1EA;padding:28px 28px 32px;font-family:system-ui,-apple-system,sans-serif;color:#131936;position:relative;';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '×';
    closeBtn.style.cssText = 'position:absolute;top:14px;right:14px;width:32px;height:32px;border:none;background:transparent;font-size:24px;line-height:1;color:#131936;cursor:pointer;font-family:inherit;';
    closeBtn.addEventListener('click', function () { dialog.close(); });
    card.appendChild(closeBtn);

    var head = document.createElement('div');
    head.innerHTML =
      '<div style="font-size:11px;letter-spacing:0.24em;text-transform:uppercase;color:#8a7960;margin-bottom:6px;">Recommended for you</div>' +
      '<h2 style="font-size:22px;letter-spacing:0.08em;text-transform:uppercase;margin:0 0 8px;font-weight:600;color:#131936;">Find My Size</h2>' +
      '<p style="font-size:13px;color:#555;margin:0 0 18px;line-height:1.55;">Enter your body measurements — we’ll recommend the right size for <strong>' + escapeHtml(product.title || 'this item') + '</strong>.</p>';
    card.appendChild(head);

    var widget = document.createElement('div');
    if (cat.kind === 'aura') widget.innerHTML = auraWidgetHtml(cat.garment);
    else widget.innerHTML = simpleWidgetHtml(cat.kind, cat.label);
    card.appendChild(widget);

    dialog.appendChild(card);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    setTimeout(function () { wireWidget(card, cat, product); }, 0);
    return dialog;
  }

  function simpleWidgetHtml(kind, label) {
    return formContainer(
      '<div style="display:flex;flex-wrap:wrap;gap:12px;align-items:flex-end;margin-bottom:14px;">' +
        '<div style="flex:1 1 180px;min-width:140px;">' +
          '<label style="display:block;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#131936;margin-bottom:6px;">Body ' + label + '</label>' +
          '<input data-input="primary" type="number" step="0.1" min="0" placeholder="e.g. 100" style="width:100%;padding:11px 12px;border:1px solid #d6cfc4;background:#fff;font-size:14px;font-family:inherit;color:#131936;">' +
        '</div>' +
        unitToggle() +
      '</div>' +
      fitToggle() +
      submitButton() +
      resultBox()
    );
  }

  function auraWidgetHtml(defaultGarment) {
    var g = function (key, label) {
      var active = (key === defaultGarment);
      return '<button type="button" data-garment="' + key + '" data-role="garment" style="padding:10px 14px;border:none;background:' + (active ? '#131936' : 'transparent') + ';color:' + (active ? '#C3B091' : '#131936') + ';font-family:inherit;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;cursor:pointer;">' + label + '</button>';
    };
    return formContainer(
      '<div style="margin-bottom:14px;">' +
        '<label style="display:block;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#131936;margin-bottom:6px;">Garment</label>' +
        '<div style="display:inline-flex;flex-wrap:wrap;border:1px solid #d6cfc4;background:#fff;">' + g('bra', 'Bra') + g('shorts', 'Shorts') + g('leggings', 'Leggings') + '</div>' +
      '</div>' +
      '<div data-fields="bra" style="display:' + (defaultGarment === 'bra' ? 'block' : 'none') + ';">' +
        '<div style="display:flex;flex-wrap:wrap;gap:12px;margin-bottom:14px;">' +
          inputField('bust', 'Bust', 'e.g. 90') +
          inputField('underbust', 'Underbust', 'e.g. 75') +
        '</div>' +
      '</div>' +
      '<div data-fields="shorts" style="display:' + (defaultGarment === 'shorts' ? 'block' : 'none') + ';">' +
        '<div style="margin-bottom:14px;">' + inputField('hip', 'Hip', 'e.g. 95') + '</div>' +
      '</div>' +
      '<div data-fields="leggings" style="display:' + (defaultGarment === 'leggings' ? 'block' : 'none') + ';">' +
        '<div style="margin-bottom:14px;">' + inputField('hip', 'Hip', 'e.g. 95') + '</div>' +
      '</div>' +
      '<div style="margin-bottom:14px;">' + unitToggle(true) + '</div>' +
      fitToggle() +
      submitButton() +
      resultBox()
    );
  }

  function formContainer(inner) { return '<div data-form style="background:#fff;border:1px solid #e8e0d6;padding:20px 22px;">' + inner + '</div>'; }
  function inputField(name, label, ph) {
    return '<div style="flex:1 1 180px;min-width:140px;">' +
      '<label style="display:block;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#131936;margin-bottom:6px;">' + label + '</label>' +
      '<input data-input="' + name + '" type="number" step="0.1" min="0" placeholder="' + ph + '" style="width:100%;padding:11px 12px;border:1px solid #d6cfc4;background:#fff;font-size:14px;font-family:inherit;color:#131936;">' +
    '</div>';
  }
  function unitToggle(labeled) {
    return (labeled ? '<div><label style="display:block;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#131936;margin-bottom:6px;">Units</label>' : '<div>') +
      '<div style="display:inline-flex;border:1px solid #d6cfc4;background:#fff;">' +
        '<button type="button" data-unit="cm" data-role="unit" style="padding:10px 14px;border:none;background:#131936;color:#C3B091;font-family:inherit;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;cursor:pointer;">cm</button>' +
        '<button type="button" data-unit="in" data-role="unit" style="padding:10px 14px;border:none;background:transparent;color:#131936;font-family:inherit;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;cursor:pointer;">in</button>' +
      '</div></div>';
  }
  function fitToggle() {
    return '<div style="margin-bottom:18px;">' +
      '<label style="display:block;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#131936;margin-bottom:6px;">Fit Preference</label>' +
      '<div style="display:inline-flex;flex-wrap:wrap;border:1px solid #d6cfc4;background:#fff;">' +
        '<button type="button" data-fit="snug" data-role="fit" style="padding:10px 14px;border:none;background:transparent;color:#131936;font-family:inherit;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;cursor:pointer;">Snug</button>' +
        '<button type="button" data-fit="true" data-role="fit" style="padding:10px 14px;border:none;background:#131936;color:#C3B091;font-family:inherit;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;cursor:pointer;">True to size</button>' +
        '<button type="button" data-fit="oversized" data-role="fit" style="padding:10px 14px;border:none;background:transparent;color:#131936;font-family:inherit;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;cursor:pointer;">Oversized</button>' +
      '</div></div>';
  }
  function submitButton() {
    return '<button type="button" data-role="submit" style="padding:12px 24px;border:none;background:#131936;color:#C3B091;font-family:inherit;font-size:11px;letter-spacing:0.16em;text-transform:uppercase;cursor:pointer;">Find My Size</button>';
  }
  function resultBox() { return '<div data-role="result" style="margin-top:18px;"></div>'; }

  function wireWidget(root, cat, product) {
    var state = { unit: 'cm', fit: 'true', garment: cat.kind === 'aura' ? cat.garment : null };

    function pick(value, ranges) {
      var r = Math.round(value);
      if (r < ranges[0][0]) return { idx: 0, flag: 'below' };
      if (r > ranges[ranges.length - 1][1]) return { idx: ranges.length - 1, flag: 'above' };
      var idx = -1;
      for (var i = 0; i < ranges.length; i++) {
        var lo = ranges[i][0], hi = ranges[i][1];
        if (i === ranges.length - 1) { if (r >= lo && r <= hi) { idx = i; break; } }
        else { if (r >= lo && r < hi) { idx = i; break; } }
      }
      if (idx === -1) idx = ranges.length - 1;
      var mid = (ranges[idx][0] + ranges[idx][1]) / 2;
      if (state.fit === 'snug' && r > mid && idx > 0) idx -= 1;
      else if (state.fit === 'oversized' && r < mid && idx < ranges.length - 1) idx += 1;
      return { idx: idx, flag: 'in' };
    }
    function setActive(role, attr, val) {
      var btns = root.querySelectorAll('[data-role="' + role + '"]');
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i].getAttribute(attr) === val;
        btns[i].style.background = on ? '#131936' : 'transparent';
        btns[i].style.color = on ? '#C3B091' : '#131936';
      }
    }
    function showFields(g) {
      root.querySelectorAll('[data-fields]').forEach(function (el) {
        el.style.display = (el.getAttribute('data-fields') === g) ? 'block' : 'none';
      });
    }
    root.querySelectorAll('[data-role="unit"]').forEach(function (b) {
      b.addEventListener('click', function () { state.unit = b.getAttribute('data-unit'); setActive('unit', 'data-unit', state.unit); });
    });
    root.querySelectorAll('[data-role="fit"]').forEach(function (b) {
      b.addEventListener('click', function () { state.fit = b.getAttribute('data-fit'); setActive('fit', 'data-fit', state.fit); });
    });
    root.querySelectorAll('[data-role="garment"]').forEach(function (b) {
      b.addEventListener('click', function () { state.garment = b.getAttribute('data-garment'); setActive('garment', 'data-garment', state.garment); showFields(state.garment); root.querySelector('[data-role="result"]').innerHTML = ''; });
    });
    function readInputCm(name, scope) {
      var inp = (scope || root).querySelector('[data-input="' + name + '"]');
      if (!inp) return null;
      var raw = parseFloat(inp.value);
      if (!raw || raw <= 0) return null;
      return { raw: raw, cm: state.unit === 'in' ? raw * 2.54 : raw };
    }
    var submit = root.querySelector('[data-role="submit"]');
    submit.addEventListener('click', function () {
      var resultEl = root.querySelector('[data-role="result"]');
      var errMsg = function (m) { resultEl.innerHTML = '<p style="font-size:13px;color:#a94442;margin:0;">' + m + '</p>'; };
      var picks = [], displayParts = [], sizes;
      if (cat.kind === 'aura') {
        sizes = SIZES_4;
        var scope = root.querySelector('[data-fields="' + state.garment + '"]');
        if (state.garment === 'bra') {
          var b = readInputCm('bust', scope); var u = readInputCm('underbust', scope);
          if (!b || !u) return errMsg('Please enter both bust and underbust measurements.');
          picks.push(pick(b.cm, RANGES.aura_bra_bust));
          picks.push(pick(u.cm, RANGES.aura_bra_underbust));
          displayParts.push('bust ' + b.raw + ' ' + state.unit, 'underbust ' + u.raw + ' ' + state.unit);
        } else {
          var h = readInputCm('hip', scope);
          if (!h) return errMsg('Please enter your hip measurement.');
          picks.push(pick(h.cm, RANGES.aura_hip));
          displayParts.push('hip ' + h.raw + ' ' + state.unit);
        }
      } else {
        sizes = SIZES_5;
        var v = readInputCm('primary');
        if (!v) return errMsg('Please enter your measurement.');
        picks.push(pick(v.cm, RANGES[cat.kind]));
        displayParts.push((cat.label || 'measurement').toLowerCase() + ' ' + v.raw + ' ' + state.unit);
      }
      var finalIdx = picks[0].idx, anyFlag = picks[0].flag;
      for (var i = 1; i < picks.length; i++) if (picks[i].idx < finalIdx) finalIdx = picks[i].idx;
      for (var j = 0; j < picks.length; j++) { if (picks[j].flag === 'above') anyFlag = 'above'; }
      for (var k = 0; k < picks.length; k++) { if (picks[k].flag === 'below') anyFlag = 'below'; }
      var size = sizes[finalIdx];
      var fitLabel = state.fit === 'snug' ? 'snug' : (state.fit === 'oversized' ? 'oversized' : 'true-to-size');
      var inputDesc = displayParts.join(' and ');
      var note;
      if (anyFlag === 'below') note = 'Based on ' + inputDesc + ', our closest fit is ' + size + ', but our smallest size may still feel roomy.';
      else if (anyFlag === 'above') note = 'Based on ' + inputDesc + ', our closest fit is ' + size + '. We recommend reaching out to <a href="mailto:info@aboutusthelabel.com" style="color:#131936;">info@aboutusthelabel.com</a> to confirm fit.';
      else note = 'Based on ' + inputDesc + ' with ' + fitLabel + ' fit, we recommend size <strong>' + size + '</strong>.';

      // Try to auto-select the matching variant on the PDP.
      var matched = false;
      try {
        if (product && product.variants) {
          for (var v2 = 0; v2 < product.variants.length; v2++) {
            var variant = product.variants[v2];
            var t = (variant.title || '').toUpperCase();
            if (t === size || t.indexOf(size) === 0 || t.indexOf('/' + size) !== -1 || t.indexOf(size + '/') !== -1 || t.indexOf(' ' + size + ' ') !== -1) {
              if (variant.available) { matched = selectVariantOnPdp(variant); break; }
            }
          }
        }
      } catch (e) {}

      resultEl.innerHTML = '<div style="background:#faf8f5;border:1px solid #d6cfc4;border-left:3px solid #C3B091;padding:18px 20px;">' +
        '<div style="font-size:11px;letter-spacing:0.16em;text-transform:uppercase;color:#131936;margin-bottom:6px;">Your size</div>' +
        '<div style="font-size:32px;color:#131936;font-weight:600;letter-spacing:0.04em;margin-bottom:8px;">' + size + '</div>' +
        '<p style="font-size:13px;color:#555;margin:0 0 12px;line-height:1.5;">' + note + '</p>' +
        (matched ? '<p style="font-size:12px;color:#8a7960;margin:0;">We’ve selected size ' + size + ' for you.</p>' : '') +
      '</div>';

      try { localStorage.setItem('aboutus.fms.size', size); } catch (e) {}
    });
  }

  function selectVariantOnPdp(variant) {
    try {
      var inputs = document.querySelectorAll('input[type="radio"][name*="option"], input[type="radio"][name*="Size"]');
      for (var i = 0; i < inputs.length; i++) {
        if ((inputs[i].value || '').toUpperCase() === (variant.title || '').toUpperCase() || ((inputs[i].value || '').toUpperCase() === (variant.option1 || '').toUpperCase() && variant.option1)) {
          inputs[i].checked = true;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
      var selects = document.querySelectorAll('select[name*="option"], select[name*="Size"]');
      for (var s = 0; s < selects.length; s++) {
        var opts = selects[s].options;
        for (var o = 0; o < opts.length; o++) {
          if ((opts[o].value || '').toUpperCase() === (variant.title || '').toUpperCase() || (opts[o].value || '').toUpperCase() === (variant.option1 || '').toUpperCase()) {
            selects[s].selectedIndex = o;
            selects[s].dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
        }
      }
    } catch (e) {}
    return false;
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]); }); }
})();
